import axiosInstance from './axiosInstance';

export interface WishlistItemDto {
  id: string;
  productId: string;
  designId: string | null;
  signature: string;
  createdAt: string;
  product?: {
    id: string;
    name: string;
    slug?: string | null;
    minPrice?: number | null;
    maxPrice?: number | null;
    favorites?: number | null;
    isCustomizable?: boolean | null;
  } | null;
  design?: {
    id: string;
    title: string;
    frontPreviewUrl?: string;
    backPreviewUrl?: string;
    frontMockupUrl?: string;
    backMockupUrl?: string;
  } | null;
}

export interface WishlistResponseDto {
  items: WishlistItemDto[];
  count: number;
}

export const wishlistService = {
  getWishlist: async (): Promise<WishlistResponseDto> => {
    const { data } = await axiosInstance.get('/wishlist');
    return data;
  },

  toggleWishlistItem: async (payload: { productId: string; designId?: string }): Promise<{
    isWishlisted: boolean;
    item: WishlistItemDto | null;
  }> => {
    const { data } = await axiosInstance.post('/wishlist/items/toggle', payload);
    return data;
  },
};

